import React from 'react';

const Commerce = () => {
  return (
    <div>
      Commerce
      Commerce
    </div>
  );
}

export default Commerce;
